module.exports = __webpack_public_path__ + "static/img/story1.a2859a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/story1.png
// module id = +gpT
// module chunks = 1